(function() {
  if (window.location.search.indexOf('adjust') === -1) return;

  var wrap = document.querySelector('.about-section');
  if (!wrap) return;

  var cs0 = getComputedStyle(wrap);
  if (cs0.position === 'static') wrap.style.position = 'relative';

  if (!document.getElementById('dbg-about-styles')) {
    var style = document.createElement('style');
    style.id = 'dbg-about-styles';
    style.textContent = [
      '.dbg-handle {',
      '  position: absolute; width: 22px; height: 22px;',
      '  background: #ff0; border: 3px solid #000;',
      '  z-index: 10002; box-shadow: 0 0 8px rgba(0,0,0,0.6);',
      '  pointer-events: auto;',
      '}',
      '.dbg-handle-tl { top: -11px; left: -11px; cursor: nwse-resize; }',
      '.dbg-handle-tr { top: -11px; right: -11px; cursor: nesw-resize; }',
      '.dbg-handle-bl { bottom: -11px; left: -11px; cursor: nesw-resize; }',
      '.dbg-handle-br { bottom: -11px; right: -11px; cursor: nwse-resize; }',
      '.dbg-handle-rot {',
      '  top: -46px; left: 50%; transform: translateX(-50%);',
      '  border-radius: 50%; background: #f0f;',
      '  cursor: grab;',
      '}',
      '.dbg-handle-rot::before {',
      '  content: ""; position: absolute; left: 50%; top: 100%;',
      '  width: 2px; height: 20px; background: #000;',
      '  transform: translateX(-50%);',
      '}',
      '.dbg-label {',
      '  position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%);',
      '  margin-bottom: 58px;',
      '  font: bold 11px monospace; color: #ff0; background: rgba(0,0,0,0.85);',
      '  padding: 3px 8px; border-radius: 4px; white-space: nowrap;',
      '  pointer-events: none; z-index: 10002;',
      '}',
      '.dbg-outline { outline: 2px dashed #ff0; outline-offset: 2px; }',
      '.dbg-active { outline-color: #0ff !important; outline-width: 3px !important; }',
      '.debug-toolbar-about {',
      '  position: fixed; bottom: 20px; left: 20px; z-index: 99999;',
      '  display: flex; gap: 8px; flex-wrap: wrap; max-width: 60vw;',
      '}',
      '.debug-btn {',
      '  background: #ff0; color: #000; border: none; padding: 12px 18px;',
      '  font: bold 13px monospace; border-radius: 8px; cursor: pointer;',
      '  box-shadow: 0 4px 14px rgba(0,0,0,0.4);',
      '}',
      '.debug-btn:hover { filter: brightness(0.92); }',
      '.debug-btn-z { background: #0ff; }',
      '.debug-btn-zp { background: #f90; }',
      '.debug-btn-primary { background: #0f0; }',
      '.debug-btn:disabled { opacity: 0.35; cursor: not-allowed; }',
    ].join('\n');
    document.head.appendChild(style);
  }

  var targets = [
    { sel: '.about-title',         cls: 'about-title' },
    { sel: '.about-body',          cls: 'about-body' },
    { sel: '.about-squiggle',      cls: 'about-squiggle' },
    { sel: '.about-photo',         cls: 'about-photo' },
    { sel: '.about-thc',           cls: 'about-thc' },
    { sel: '.about-smiley',        cls: 'about-smiley' },
    { sel: '.about-sticker-leaf',  cls: 'about-sticker-leaf' },
    { sel: '.about-delicious',     cls: 'about-delicious' },
  ];

  var handles = [];
  var activeH = null;
  var LIFT_ACTIVE = 99990;
  var LIFT_PARENT = 99989;

  function extractRotationDeg(transformStr) {
    if (!transformStr || transformStr === 'none') return 0;
    if (transformStr.indexOf('matrix') === 0) {
      var vals = transformStr.match(/-?\d+\.?\d*(?:e[+-]?\d+)?/g);
      if (!vals || vals.length < 4) return 0;
      var a = parseFloat(vals[0]), b = parseFloat(vals[1]);
      return Math.atan2(b, a) * 180 / Math.PI;
    }
    var m = transformStr.match(/rotate\(([-\d.]+)deg\)/);
    return m ? parseFloat(m[1]) : 0;
  }

  function applyTransform(el) {
    var rot = parseFloat(el.dataset.rotation || '0');
    el.style.transform = 'rotate(' + rot.toFixed(2) + 'deg)';
  }

  function parentHandleOf(h) {
    if (!h) return null;
    return handles.find(function(x) { return x.el === h.parent; }) || null;
  }

  function restoreZ(h) {
    h.el.style.zIndex = h.el.dataset.zindex || '';
  }

  function setActive(h) {
    if (activeH && activeH !== h) {
      restoreZ(activeH);
      var prevParent = parentHandleOf(activeH);
      if (prevParent) restoreZ(prevParent);
    }
    handles.forEach(function(x) { x.el.classList.remove('dbg-active'); });
    activeH = h;
    if (h) {
      h.el.classList.add('dbg-active');
      h.el.style.zIndex = String(LIFT_ACTIVE);
      var ph = parentHandleOf(h);
      if (ph) ph.el.style.zIndex = String(LIFT_PARENT);
      updateParentButtons();
    } else {
      updateParentButtons();
    }
  }

  targets.forEach(function(t) {
    var raw = document.querySelector(t.sel);
    if (!raw) return;
    var parent = t.parentSel ? document.querySelector(t.parentSel) : wrap;
    if (!parent) return;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';

    var el = raw;

    if (raw.tagName === 'IMG') {
      var cs = getComputedStyle(raw);
      var initialRot = extractRotationDeg(cs.transform);
      var wrapper = document.createElement('div');
      wrapper.style.position = 'absolute';
      wrapper.style.top = cs.top;
      wrapper.style.left = cs.left;
      wrapper.style.right = cs.right;
      wrapper.style.bottom = cs.bottom;
      wrapper.style.width = cs.width;
      wrapper.style.zIndex = cs.zIndex === 'auto' ? '' : cs.zIndex;
      wrapper.className = 'dbg-img-wrap';
      raw.parentNode.insertBefore(wrapper, raw);
      wrapper.appendChild(raw);
      raw.style.position = 'relative';
      raw.style.top = raw.style.left = raw.style.right = raw.style.bottom = 'auto';
      raw.style.width = '100%';
      raw.style.height = 'auto';
      raw.style.display = 'block';
      raw.style.transform = 'none';
      wrapper.dataset.rotation = initialRot.toFixed(2);
      wrapper.dataset.zindex = cs.zIndex === 'auto' ? '' : cs.zIndex;
      applyTransform(wrapper);
      el = wrapper;
    } else {
      var csEl = getComputedStyle(el);
      var rotExisting = extractRotationDeg(csEl.transform);
      el.dataset.rotation = rotExisting.toFixed(2);
      el.dataset.zindex = csEl.zIndex === 'auto' ? '' : csEl.zIndex;
      applyTransform(el);
    }

    el.classList.add('dbg-outline');
    el.style.cursor = 'grab';

    ['tl','tr','bl','br','rot'].forEach(function(c) {
      var h = document.createElement('div');
      h.className = 'dbg-handle dbg-handle-' + c;
      h.dataset.corner = c;
      el.appendChild(h);
    });

    var label = document.createElement('div');
    label.className = 'dbg-label';
    el.appendChild(label);

    handles.push({ el: el, parent: parent, cls: t.cls, parentSel: t.parentSel || null });
  });

  var dragging = null;
  var resizeInfo = null;
  var rotateInfo = null;
  var dragStart = {};

  handles.forEach(function(h) {
    var el = h.el;

    el.addEventListener('mousedown', function(e) {
      if (e.target.classList.contains('dbg-handle')) return;
      e.preventDefault();
      e.stopPropagation();
      setActive(h);
      dragging = h;
      el.style.cursor = 'grabbing';
      var parentRect = h.parent.getBoundingClientRect();
      var rect = el.getBoundingClientRect();
      dragStart = {
        mx: e.clientX, my: e.clientY,
        left: rect.left - parentRect.left,
        top: rect.top - parentRect.top
      };
    });

    el.querySelectorAll('.dbg-handle').forEach(function(hh) {
      hh.addEventListener('mousedown', function(e) {
        e.preventDefault();
        e.stopPropagation();
        setActive(h);
        var corner = hh.dataset.corner;

        if (corner === 'rot') {
          var rect = el.getBoundingClientRect();
          var cx = rect.left + rect.width / 2;
          var cy = rect.top + rect.height / 2;
          var startAngle = Math.atan2(e.clientY - cy, e.clientX - cx) * 180 / Math.PI;
          rotateInfo = {
            h: h,
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            startRot: parseFloat(el.dataset.rotation || '0')
          };
          return;
        }

        var rect2 = el.getBoundingClientRect();
        var parentRect2 = h.parent.getBoundingClientRect();
        resizeInfo = {
          h: h,
          corner: corner,
          startX: e.clientX,
          startY: e.clientY,
          startW: rect2.width,
          startH: rect2.height,
          startLeft: rect2.left - parentRect2.left,
          startTop: rect2.top - parentRect2.top,
          aspect: rect2.width / rect2.height
        };
      });
    });
  });

  document.addEventListener('mousemove', function(e) {
    if (dragging) {
      e.preventDefault();
      var h = dragging;
      var parentRect = h.parent.getBoundingClientRect();
      var dx = e.clientX - dragStart.mx;
      var dy = e.clientY - dragStart.my;
      h.el.style.left = (dragStart.left + dx) / parentRect.width * 100 + '%';
      h.el.style.top = (dragStart.top + dy) / parentRect.height * 100 + '%';
      h.el.style.right = 'auto';
      h.el.style.bottom = 'auto';
      updateLabels();
    }

    if (resizeInfo) {
      e.preventDefault();
      var r = resizeInfo;
      var parentRect = r.h.parent.getBoundingClientRect();
      var dx = e.clientX - r.startX;
      var newW, newLeft, newTop, newH;

      if (r.corner === 'br') {
        newW = r.startW + dx;
        newLeft = r.startLeft;
        newTop = r.startTop;
      } else if (r.corner === 'bl') {
        newW = r.startW - dx;
        newLeft = r.startLeft + dx;
        newTop = r.startTop;
      } else if (r.corner === 'tr') {
        newW = r.startW + dx;
        newH = newW / r.aspect;
        newLeft = r.startLeft;
        newTop = r.startTop - (newH - r.startH);
      } else if (r.corner === 'tl') {
        newW = r.startW - dx;
        newH = newW / r.aspect;
        newLeft = r.startLeft + (r.startW - newW);
        newTop = r.startTop - (newH - r.startH);
      }

      if (newW < 20) newW = 20;
      r.h.el.style.width = (newW / parentRect.width * 100) + '%';
      r.h.el.style.left = (newLeft / parentRect.width * 100) + '%';
      r.h.el.style.top = (newTop / parentRect.height * 100) + '%';
      r.h.el.style.right = 'auto';
      r.h.el.style.bottom = 'auto';
      r.h.el.style.height = 'auto';
      updateLabels();
    }

    if (rotateInfo) {
      e.preventDefault();
      var ri = rotateInfo;
      var currentAngle = Math.atan2(e.clientY - ri.cy, e.clientX - ri.cx) * 180 / Math.PI;
      var delta = currentAngle - ri.startAngle;
      var newRot = ri.startRot + delta;
      if (e.shiftKey) newRot = Math.round(newRot / 15) * 15;
      ri.h.el.dataset.rotation = newRot.toFixed(2);
      applyTransform(ri.h.el);
      updateLabels();
    }
  });

  document.addEventListener('mouseup', function() {
    if (dragging) dragging.el.style.cursor = 'grab';
    dragging = null;
    resizeInfo = null;
    rotateInfo = null;
  });

  function updateLabels() {
    handles.forEach(function(h) {
      var parentRect = h.parent.getBoundingClientRect();
      var rect = h.el.getBoundingClientRect();
      var label = h.el.querySelector('.dbg-label');
      if (!label) return;
      var l = ((rect.left - parentRect.left) / parentRect.width * 100).toFixed(1);
      var t = ((rect.top - parentRect.top) / parentRect.height * 100).toFixed(1);
      var w = (rect.width / parentRect.width * 100).toFixed(1);
      var rot = parseFloat(h.el.dataset.rotation || '0').toFixed(1);
      var z = h.el.dataset.zindex || '-';
      label.textContent = h.cls + ' W:' + w + '% L:' + l + ' T:' + t + ' R:' + rot + '° Z:' + z;
    });
  }

  // Toolbar
  var toolbar = document.createElement('div');
  toolbar.className = 'debug-toolbar-about';
  document.body.appendChild(toolbar);

  function btn(txt, cls, onClick) {
    var b = document.createElement('button');
    b.className = 'debug-btn' + (cls ? ' ' + cls : '');
    b.textContent = txt;
    b.addEventListener('click', onClick);
    toolbar.appendChild(b);
    return b;
  }

  function bumpZ(h, delta) {
    var cur = parseInt(h.el.dataset.zindex || '0', 10);
    if (isNaN(cur)) cur = 0;
    var next = cur + delta;
    h.el.dataset.zindex = String(next);
    if (h !== activeH && !(activeH && parentHandleOf(activeH) === h)) {
      h.el.style.zIndex = String(next);
    }
    updateLabels();
  }

  btn('Z ↑', 'debug-btn-z', function() { if (activeH) bumpZ(activeH, +1); });
  btn('Z ↓', 'debug-btn-z', function() { if (activeH) bumpZ(activeH, -1); });

  var parentUpBtn = btn('Parent Z ↑', 'debug-btn-zp', function() {
    var ph = parentHandleOf(activeH);
    if (ph) bumpZ(ph, +1);
  });
  var parentDnBtn = btn('Parent Z ↓', 'debug-btn-zp', function() {
    var ph = parentHandleOf(activeH);
    if (ph) bumpZ(ph, -1);
  });

  btn('Reset rot', '', function() {
    if (!activeH) return;
    activeH.el.dataset.rotation = '0';
    applyTransform(activeH.el);
    updateLabels();
  });

  function updateParentButtons() {
    var hasParent = !!(activeH && parentHandleOf(activeH));
    parentUpBtn.disabled = !hasParent;
    parentDnBtn.disabled = !hasParent;
  }
  updateParentButtons();

  var exportBtn = btn('EXPORT ABOUT POSITIONS', 'debug-btn-primary', function() {
    var output = '/* EXPORTED ABOUT POSITIONS */\n\n';

    handles.forEach(function(h) {
      var parentRect = h.parent.getBoundingClientRect();
      var rect = h.el.getBoundingClientRect();
      var l = ((rect.left - parentRect.left) / parentRect.width * 100).toFixed(1);
      var t = ((rect.top - parentRect.top) / parentRect.height * 100).toFixed(1);
      var w = (rect.width / parentRect.width * 100).toFixed(1);
      var rot = parseFloat(h.el.dataset.rotation || '0');
      var z = h.el.dataset.zindex || '';

      output += '.' + h.cls + ' {\n';
      output += '  width: ' + w + '%;\n';
      output += '  top: ' + t + '%;\n';
      output += '  left: ' + l + '%;\n';
      if (Math.abs(rot) > 0.05) output += '  transform: rotate(' + rot.toFixed(1) + 'deg);\n';
      if (z !== '') output += '  z-index: ' + z + ';\n';
      output += '}\n\n';
    });

    navigator.clipboard.writeText(output).then(function() {
      exportBtn.textContent = 'COPIED!';
      exportBtn.style.background = '#4f4';
      setTimeout(function() {
        exportBtn.textContent = 'EXPORT ABOUT POSITIONS';
        exportBtn.style.background = '#0f0';
      }, 2000);
    });
    console.log(output);
  });

  setTimeout(updateLabels, 500);
})();
